// extracted by mini-css-extract-plugin
export default {"successIcon":"customPreIcon_successIcon__8ID4K","warningIcon":"customPreIcon_warningIcon__Zanee","dangerIcon":"customPreIcon_dangerIcon__pKzT3"};